import React from 'react';
import withIcon from '../utilities/withIcon';

const IconCart = () => {
  return (
    <g>
      <path d="M6.75 11.5a2.25 2.25 0 1 1 0 4.5 2.25 2.25 0 0 1 0-4.5zm6 0a2.25 2.25 0 1 1 0 4.5 2.25 2.25 0 0 1 0-4.5zm-6 1.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5zm6 0a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5zM2.471 0c.782 0 1.465.506 1.69 1.234l.04.148.354 1.644H14.99a1.004 1.004 0 0 1 1 1.14l-.722 5.477a1.006 1.006 0 0 1-1 .857H5.35c-.476 0-.888-.329-.988-.789L3.194 3.9l-.476-2.206a.25.25 0 0 0-.178-.188l-.069-.01-1.713.025A.753.753 0 0 1 0 .773C0 .393.285.08.655.03L.758.024 2.47 0zm11.594 4.523H5.257a.3.3 0 0 0-.295.357l.75 3.88a.3.3 0 0 0 .295.243h7.558a.3.3 0 0 0 .297-.261l.5-3.88a.3.3 0 0 0-.258-.336l-.039-.003z" />
    </g>
  );
};

export default withIcon(IconCart);
